import { useMemo } from "react";
import { useImmerReducer } from "use-immer";
import { useMutation } from "@apollo/client";

//Components
import {
  FormControl,
  Checkbox,
  FormControlLabel,
  Fab,
} from "@material-ui/core";
import { KeyboardDatePicker } from "@material-ui/pickers";

//Styling
import { useStyles } from "../Styles/styles";
import deleteButton from "../Assets/deleteButton.png";

//Utils
import AddressWithAlertAndHmi from "./AddressWithAlertAndHmi";
import { shouldBeLocked } from "../utils/Roles";
import PersonAutoSuggestRefactor from "./PersonAutoSuggestRefactor";
import PhoneInputRefactor from "./PhoneInputRefactor";

import _ from "lodash";
import { createEmptyPerson } from "../utils/EmptyObjects";
import { ADD_OR_UPDATE_PERSON } from "../Mutations/AddOrUpdatePerson";
import moment from "moment";

const PERSON_ACTIONS = {
  CHANGE_BUSINESS: "change-business",
  CHANGE_DOB: "change-dob",
  CHANGE_PHONE: "change-phone",
  MERGE_PERSON: "merge-person",
  CHANGE_ADDRESS: "change-address",
};

const {
  CHANGE_BUSINESS,
  CHANGE_DOB,
  CHANGE_PHONE,
  MERGE_PERSON,
  CHANGE_ADDRESS,
} = PERSON_ACTIONS;

const personReducer = (state, action) => {
  console.log(action.type);
  console.log(action.payload);

  switch (action.type) {
    case CHANGE_BUSINESS:
      state.person.personalAttribute.organization = action.payload;
      return state;

    case CHANGE_DOB:
      if (action.payload.isValid()) {
        const serverTimeFormat = action.payload
          .utc()
          .format("YYYY-MM-DD HH:mm:ss UTC");
        state.person.personalAttribute.dob = serverTimeFormat;
      } else {
        state.person.personalAttribute.dob = "";
      }
      return state;

    case CHANGE_PHONE:
      state.person.personalAttribute.phone = action.payload;
      return state;

    case CHANGE_ADDRESS:
      state.person.personalAttribute.homeAddress = action.payload;
      return state;

    case MERGE_PERSON:
      return _.merge(state, action.payload);

    default:
      return state;
  }
};

const PersonPersonalAttributes = ({
  person,
  personDispatch,
  handleAddPerson,
  handleUpdatePerson,
  setPausePolling,
  ...props
}) => {
  const memoizedLocked = useMemo(
    () => shouldBeLocked(props.disabled, props?.canEdit, props.userRoles),
    [props.disabled, props?.canEdit, props.userRoles]
  );

  const classes = useStyles();

  const address = {
    id:
      person && person.personalAttribute?.homeAddress
        ? person.personalAttribute.homeAddress.id
        : "",
    city:
      person && person.personalAttribute?.homeAddress
        ? person.personalAttribute.homeAddress.city
        : "",
    lat:
      person && person.personalAttribute?.homeAddress
        ? person.personalAttribute.homeAddress.lat
        : "",
    lng:
      person && person.personalAttribute?.homeAddress
        ? person.personalAttribute.homeAddress.lng
        : "",
    addressName:
      person && person.personalAttribute?.homeAddress
        ? person.personalAttribute.homeAddress.name
        : "",
    state:
      person && person.personalAttribute?.homeAddress
        ? person.personalAttribute.homeAddress.state
        : "",
    streetName:
      person && person.personalAttribute?.homeAddress
        ? person.personalAttribute.homeAddress.streetName
        : "",
    streetNumber:
      person && person.personalAttribute?.homeAddress
        ? person.personalAttribute.homeAddress.streetNumber
        : "",
    unit:
      person && person.personalAttribute?.homeAddress
        ? person.personalAttribute.homeAddress.unit
        : "",
    zip:
      person && person.personalAttribute?.homeAddress
        ? person.personalAttribute.homeAddress.zip
        : "",
    validAddressAlerts:
      person && person.personalAttribute?.homeAddress
        ? person && person.personalAttribute?.homeAddress?.validAddressAlerts
        : [],
  };

  const handlePhoneChange = phoneNumber => {
    handleUpdatePerson(person, CHANGE_PHONE, phoneNumber);
  };

  const handleAddressUpdate = address => {
    handleUpdatePerson(person, CHANGE_ADDRESS, address);
  };

  return (
    <>
      <FormControl
        data-cy={"business-checkbox-FormControl-" + person?.id}
        variant="outlined"
        className={classes.formControl}
      >
        <FormControlLabel
          control={
            <Checkbox
              inputProps={{ "data-cy": "business-checkbox-" + person?.id }}
              checked={person?.personalAttribute?.organization || false}
              // onChange={(e) => personDispatch({ type: CHANGE_BUSINESS, payload: e.target.checked })}
              onChange={e =>
                handleUpdatePerson(person, CHANGE_BUSINESS, e.target.checked)
              }
              value="organization"
              color="primary"
              disabled={memoizedLocked}
            />
          }
          label="Bus."
        />
      </FormControl>
      <PersonAutoSuggestRefactor
        person={person}
        canEdit={props.canEdit}
        dispatch={personDispatch}
        action={MERGE_PERSON}
        mergePersonAction={MERGE_PERSON}
        handleAddPerson={handleAddPerson}
        userRoles={props.userRoles}
        userId={props.userId}
        handlePhoneChange={handlePhoneChange}
        containerStyle={{
          border: "1px solid grey",
          borderRadius: "5px",
          padding: "5px",
          flexGrow: 1,
          display: "flex",
        }}
      >
        <Fab
          data-cy={"person-history-button-" + person?.id}
          className={classes.fabButton}
          style={{ backgroundColor: "#49a667" }}
          onClick={() => alert("Open person in a tab")}
        >
          I
        </Fab>
      </PersonAutoSuggestRefactor>

      <KeyboardDatePicker
        data-cy={"person-dob-picker-" + person?.id}
        inputProps={{ "data-cy": "person-dob-picker-input-" + person?.id }}
        InputLabelProps={{ shrink: true }}
        clearable
        label="DOB"
        value={
          person?.personalAttribute?.dob
            ? moment
                .utc(person?.personalAttribute?.dob, "YYYY-MM-DD HH:mm:ss UTC")
                .local()
            : null
        }
        // onChange={(date) => personDispatch({ type: CHANGE_DOB, payload: date })}
        onChange={date => handleUpdatePerson(person, CHANGE_DOB, date)}
        format="MM/DD/YYYY"
        // style={{ width: '150px', }}
        style={{ margin: "8px", flexGrow: 1 }}
        className={classes.smallMatchMargin}
        disabled={memoizedLocked}
        disableFuture={true}
        inputVariant="outlined"
      />
      <PhoneInputRefactor
        setPhoneNumber={handlePhoneChange}
        phoneString={person?.personalAttribute?.phone || ""}
        personId={person?.id ? person?.id : person?.uuid}
        modalClass={classes.modal}
        inputClass={classes.modalInput}
        paperClass={classes.paper}
        title={"Phone"}
        propertyName={"phone"}
        textFieldClass={classes.smallMatchMargin}
        textFieldStyle={{ flexGrow: 1 }}
        userRoles={props.userRoles}
        canEdit={props.canEdit}
        containerStyle={{
          display: "flex",
          border: "1px solid grey",
          borderRadius: "5px",
          flexGrow: 1,
          margin: "8px",
        }}
      />

      <AddressWithAlertAndHmi
        address={address}
        showHmi={true}
        showAlert={false}
        addressInputLabel={"Address"}
        setPausePolling={setPausePolling}
        setAddress={handleAddressUpdate}
        onFocus={() => setPausePolling(true)}
        onBlur={() => setPausePolling(false)}
        validAlertName={"validAddressAlerts"}
        alertType={"address"}
        userRoles={props.userRoles}
        containerStyle={{
          border: "1px solid grey",
          borderRadius: "5px",
          flexGrow: 1,
        }}
        {...props}
      />
    </>
  );
};

const PersonRefactor = ({
  targetId,
  personData,
  relationshipType,
  disabled = undefined,
  userRoles,
  userId,
  removePerson,
  containerId,
  addPersonToRelationship,
  setPausePolling,
  ...props
}) => {
  const [{ person }, personDispatch] = useImmerReducer(personReducer, {
    person: personData || createEmptyPerson(),
  });

  // const { user } = useContext(UserContext)
  /*******This is only for development. The immer state isn't visible in the Components inspector so it's being mirrored below. Delete when done.*******/
  // const [mirror, setMirror] = useState(person)
  // useEffect(() => { setMirror(person) }, [person])

  const [addOrUpdatePerson] = useMutation(ADD_OR_UPDATE_PERSON, {
    context: { serializationKey: "incidentQueue" },
  });

  const handleAddPerson = person => {
    addPersonToRelationship(containerId, person?.id);
    personDispatch({ type: MERGE_PERSON, payload: { person: person } });
  };

  const handleUpdatePerson = (person, action, value) => {
    let input = {
      originatorId: userId,
      personId: person?.id,
    };
    if (action === CHANGE_BUSINESS) {
      input.organization = value;
    }
    if (action === CHANGE_DOB) {
      input.dob = value;
    }
    if (action === CHANGE_PHONE) {
      input.phone = value;
    }
    if (action === CHANGE_ADDRESS) {
      input.homeAddressId = value?.id || "";
    }
    addOrUpdatePerson({ variables: { input } });
    personDispatch({ type: action, payload: value });
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        marginBottom: "4vh",
      }}
    >
      <div
        data-cy={"personRefactor-div-wrapper-" + personData?.id}
        style={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          border: "1px solid grey",
          borderRadius: "5px",
          padding: "5px",
        }}
        autoComplete="off"
      >
        {/* This will either be the Person Type or the Relationship Type - either will need a targetId for the mutation */}
        {props.children}
        <PersonPersonalAttributes
          userRoles={userRoles}
          disabled={disabled}
          //passing the whole person as the alerts are separate from the personal attributes
          person={person}
          personDispatch={personDispatch}
          canEdit={props.canEdit}
          userId={userId}
          handleAddPerson={handleAddPerson}
          handleUpdatePerson={handleUpdatePerson}
          setPausePolling={setPausePolling}
        />
        {/* <FormControl style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', flexGrow: 1, justifyContent: 'flex-end' }} className={classes.formControl}>
        <img data-cy={"delete-person-button-" + person?.id} src={deleteButton} onClick={!memoizedLocked ? () => removePerson(pis.id, numOfPersons) : null} className={classes.pngButton} alt="Delete Person" />
      </FormControl> */}
      </div>
      <button
        type="button"
        onClick={() => removePerson(containerId)}
        style={{ background: "none", border: 0, padding: 0 }}
      >
        <img
          data-cy={"delete-person-button-" + personData?.id}
          src={deleteButton}
          style={style.pngButton}
          alt="Delete Relationship"
        />
      </button>
    </div>
  );
};

export { personReducer, PERSON_ACTIONS };
export default PersonRefactor;

const style = {
  pngButton: {
    maxWidth: "30px",
    maxHeight: "30px",
    minWidth: "2vw",
    minHeight: "2vw",
    margin: "8px",
    "&:hover": {
      opacity: 0.6,
      cursor: "pointer",
    },
  },
};
